export const gridRowsMetaSelector = state => state.rowsMeta;


//////////////////
// WEBPACK FOOTER
// ../@mui/x-data-grid/hooks/features/rows/gridRowsMetaSelector.js
// module id = 255
// module chunks = 25